import { DataFetchingClient, getDataFetchingClientContext } from 'data-fetching-client';
import { useContext, useState } from 'react';
export default function useCollaborationSidebarDataFetchingClient() {
  const maybeDataFetchingClient = useContext(getDataFetchingClientContext());
  const [collaborationSidebarDataFetchingClient] = useState(() => {
    if (maybeDataFetchingClient.client) {
      return maybeDataFetchingClient.client;
    }
    return new DataFetchingClient({
      /**
       * Because this is our own client we can enable this safely. I'm not sure how
       * many apps aren't using DFC these days, so it may never come into effect.
       */
      assumeImmutableResults: true
    });
  });
  return collaborationSidebarDataFetchingClient;
}